import React, { useState } from 'react'
import { DataTable } from 'components/DataTable'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import { Modal } from 'components/Modal'

import { DateTimePicker, Checkbox } from 'components/forms'

import gql from 'graphql-tag'

const query = gql`
	query listLoyaltyCardPointsByDay($params: ListQueryArgs!, $day: Date!) {
	  cashAssist {
			listLoyaltyCardPointsByDay(
		      day: $day
		      params: $params
	    	) {
		        id
		        name
		        points
		        balance
		        isActive
	    	}
	  	}
	}
`

const DatPoints = props => {
	const [day, setDay] = useState(new Date())
	const [t] = useTranslation()

	return(
		<Modal {...props} width={600} label={t('loyalty_card_section.strings.balancePerDay')}>
			<DateTimePicker noForm picker='date' value={day} onChange={setDay}/>
			<DataTable
				columns={[{
					Header: t('common.fields.code'),
					accessor: 'id'
				}, {
					Header: t('loyalty_card_section.fields.card_name'),
					accessor: 'name'
				}, {
					Header: t('loyalty_card_section.fields.points'),
					accessor: 'points'
				}, {
					Header: t('loyalty_card_section.strings.balance'),
					accessor: 'balance'
				}, {
					Header: t('common.fields.isActive'),
					accessor: 'isActive',
					width: 70,
					Cell: ({ value }) => {
						return(
							<Checkbox
								noForm
								readOnly
								checked={value}
							/>
						)
					}
				}]}
				remoteOptions={{
					query,
					variables: { day: new Date(day).toISOString().split('T')[0] },
				}}
				label={t('common.strings.preview')}
				height={480}
				withSearch
			/>
		</Modal>
	)
}

export default DatPoints
